import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Expertise", href: "#expertise" },
  { label: "Work", href: "#work" },
  { label: "Editorial", href: "#editorial" },
  { label: "Advocacy", href: "#advocacy" },
  { label: "Contact", href: "#contact" },
  { label: "Book", href: "#book" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F9F7F2]/92 backdrop-blur-md border-b border-[#E5E0D8]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-2xl md:text-[26px] tracking-tight text-navy"
        >
          Amanda <span className="italic text-terracotta">Abbott</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[15px] tracking-wide text-navy hover:text-terracotta transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-button"
          className="hidden lg:inline-flex btn-primary !min-h-[44px] !py-2.5 !px-5 !text-[14px]"
        >
          Work with me
        </a>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle navigation"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-navy p-2"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#F9F7F2] border-t border-[#E5E0D8] px-6 py-6 space-y-4"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className="block text-lg text-navy hover:text-terracotta font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-cta"
            className="btn-primary inline-flex"
          >
            Work with me
          </a>
        </div>
      )}
    </header>
  );
}
